import { fleetManagementApi } from "../api";

const VEHICLES_ENDPOINT = "/vehicles";

export const getVehicles = async (params) => {
  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await fleetManagementApi.get(`${VEHICLES_ENDPOINT}?${queryParams}`);
    return response;
  }
  const response = await fleetManagementApi.get(VEHICLES_ENDPOINT);
  return response;
};

export const getVehicleById = async (vehicleId) => {
  const response = await fleetManagementApi.get(`${VEHICLES_ENDPOINT}/${vehicleId}`);
  return response;
};

export const createVehicle = async (vehicleData) => {
  const response = await fleetManagementApi.post(VEHICLES_ENDPOINT, vehicleData);
  return response;
};

export const updateVehicle = async (vehicleId, vehicleData) => {
  const response = await fleetManagementApi.put(`${VEHICLES_ENDPOINT}/${vehicleId}`, vehicleData);
  return response;
};

export const deleteVehicle = async (vehicleId) => {
  const response = await fleetManagementApi.delete(`${VEHICLES_ENDPOINT}/${vehicleId}`);
  return response;
};
